import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

const BASE = "/superadmin";

function handle<T>(p: Promise<T>): Promise<T> {
  return p.catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
}

export default {
  /** KPI dashboard superadmin (kunjungan, sensus, login, audit, tren). */
  overview() {
    return handle(http.getData(`${BASE}/dashboard/overview`));
  },

  /** Ekspor daftar user & hak akses (format: xlsx | csv) — response blob. */
  exportUsers(format: string) {
    return handle(
      http.getDataParam(`${BASE}/export/users`, {
        params: { format },
        responseType: "blob"
      })
    );
  },

  /** Ekspor log login (format: xlsx | csv, + filter periode/ip/status). */
  exportLogins(format: string, params: Record<string, any> = {}) {
    return handle(
      http.getDataParam(`${BASE}/export/logins`, {
        params: { format, ...params },
        responseType: "blob"
      })
    );
  },

  /** Ekspor sensus ranap berjalan (pasien dirawat saat ini) — blob. */
  exportCensus(format: string) {
    return handle(
      http.getDataParam(`${BASE}/export/census`, {
        params: { format },
        responseType: "blob"
      })
    );
  },

  /** Ekspor kunjungan/registrasi lintas layanan (rentang tanggal) — blob. */
  exportVisits(format: string, params: Record<string, any> = {}) {
    return handle(
      http.getDataParam(`${BASE}/export/visits`, {
        params: { format, ...params },
        responseType: "blob"
      })
    );
  },

  auditList(params: Record<string, any> = {}) {
    return handle(http.getDataParam(`${BASE}/audit`, { params }));
  },

  auditMeta() {
    return handle(http.getData(`${BASE}/audit/meta`));
  },

  exportAudit(format: string, params: Record<string, any> = {}) {
    return handle(
      http.getDataParam(`${BASE}/export/audit`, {
        params: { format, ...params },
        responseType: "blob"
      })
    );
  }
};
